import { Paragraph } from 'ui/components';
import styles from './ProductDescriptionContent.module.scss';
import classNames from 'classnames';

export interface ProductDescriptionContentProps {
	id?: string;
	text?: string;
	text2?: string;
	isActive?: string;
	safetyDatasheets?: { countryCode: string; url: string }[];
	productName?: string;
	dictionary: { [key: string]: string };
	countryChosen?: boolean;
}

export const ProductDescriptionContent: React.FC<ProductDescriptionContentProps> = ({
	id,
	text,
	text2,
	isActive,
	safetyDatasheets,
	productName,
	dictionary,
	countryChosen,
}) => {
	return (
		<div className={classNames(styles.ProductDescriptionContent, isActive === id ? styles.isActive : '')}>
			{/* <RichText content={text} />
				<RichText content={text2} /> */}
			{/* TODO: Skal dette være en rich text? */}
			{text && <span dangerouslySetInnerHTML={{ __html: text }}></span>}
			{text2 && <span dangerouslySetInnerHTML={{ __html: text2 }}></span>}
			{safetyDatasheets?.length > 0 &&
				(countryChosen ? (
					<div className={styles.ProductDescriptionContent_safetyDataSheet}>
						<p>{dictionary.downloadSafetyDataSheet}</p>
						{safetyDatasheets.map((safetyDatasheet, index) => (
							<div key={index}>
								<a
									href={safetyDatasheet.url}
									className={classNames(styles.ProductDescriptionContent_safetyDataSheetLink, styles[`Link___primary`])}
								>
									{safetyDatasheet.countryCode} - {dictionary.safetyDataSheet}: {productName}
								</a>
							</div>
						))}
					</div>
				) : (
					<Paragraph className={styles.ProductDescriptionContent_safetyDataSheetText} style="md">
						{dictionary.chooseCountryToDownload}
					</Paragraph>
				))}
		</div>
	);
};
